import supportModule from '../../support.module';
import template from './supportViewCaseDetail.component.html';
import style from './supportViewCaseDetail.component.css';

export default supportModule.component('supportViewCaseDetail', {
    template,
    style,
    bindings: {
        caseid: '<',
        description: '<',
        status: '<',
        subject: '<',
        updatedDate: '<'
    },
    controller() {
        var vm = this;

        vm.renderCaseStatusPopover = () => {
            switch (vm.status) {
                case 'open':
                case 'closed':
                case 'resolved':
                    return `This case is ${vm.status}.`;
                default:
                    return;
            }
        };
    }
});



// WEBPACK FOOTER //
// ./modules/support/components/support-view-case-detail/supportViewCaseDetail.component.js